// extracted by mini-css-extract-plugin
export default {"icon":"ASu0w","dangerZone":"fvDEX","appLock":"ltZmy","maskableIconWapper":"QrOmz","maskableIcon":"p9se7","wrappedIcon":"o6xBR"};